<template>
    <div class="stats-inner-box" :style="{'background-color': background_color}">
        <div class="row" style="height: 100%">
            <div class="col-8">
              <p class="stats-title">{{title}}</p>
              <p class="stats-value font-weight-bold">
                {{ !value.includes('NaN') ? value : 0 }}
                <span
                    v-if="sub_value != null"
                    class="stats-value-support"
                    style="font-size:14px;"
                >({{!sub_value.includes('NaN') ? sub_value : 0 }})</span>
              </p>
            </div>
            <div class="col-4 icon">
              <i class="fas" :class="['fa-'+icon]"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : ['title', 'value', 'sub_value', 'icon', 'background_color'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 100%;
    /* padding-bottom:10px */
  }

  .stats-inner-box p, .stats-inner-box h2{
    color: white;
  }
  .stats-inner-box p{
    margin:7.5% 0 0 10%;
  }
  .stats-inner-box .stats-title{
      font-size:1.2em;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    margin-bottom:20px;
    font-size: 2.75em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }
</style>